import Item from "../Item/Item";

const ItemList = ({ producto }) => {
  return (
    <div className="w-full px-4 py-6">
      {/* Título opcional */}
      <h2 className="text-center text-2xl font-bold text-gray-800 mb-6">
        Nuestros Productos
      </h2>

      {/* Grilla de productos */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 place-items-center">
        {producto?.length > 0 ? (
          producto.map((prod) => <Item key={prod.id} {...prod} />)
        ) : (
          <p className="text-center text-gray-500 col-span-full">
            No hay productos disponibles.
          </p>
        )}
      </div>
    </div>
  );
};

export default ItemList;
